import { observable, action, computed } from 'mobx'

export default class PrerealtimeChallenge {
  @observable selectedChoice = null
  @observable choices = []

  constructor ({ challenge }) {
    Object.assign(this, challenge)
  }

  @action setAnswer (choice) {
    this.selectedChoice = choice
  }

  @computed get answer () {
    return this.choices.indexOf(this.selectedChoice)
  }
}



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/PrerealtimeChallenge/Challenge.js